import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryCounts.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryCounts_get_location_filter_xml_string_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { locationIds?: number[], onlyEmptyLocations?: boolean, includeEmptyLocations?: boolean, skipHardAllocationLocations?: boolean, skipLocationsWithReleasedCountTask?: boolean }): Promise<{ locationFilterXmlString?: string, errors?: string[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/functions/get_location_filter_xml_string_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

